import React from "react";
import {
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogContent,
  CardActionArea,
  Button,
  Grow,
  Box,
  Skeleton,
} from "@mui/material";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

import head from "img/043.png";
import wrong from "img/004.png";
import correct from "img/005.png";
import scammer from "img/006.png";
import CloseIcon from "@mui/icons-material/Close";


import ico1 from "img/B-01.jpg";
import ico2 from "img/B-02.jpg";

import ico3 from "img/A-10.jpg";
import ico4 from "img/A-01.jpg";
import ico5 from "img/A-02.jpg";
import ico6 from "img/A-03.jpg";
import ico7 from "img/A-04.jpg";
import ico8 from "img/A-05.jpg";
import ico9 from "img/A-06.jpg";
import ico10 from "img/A-07.jpg";
import ico11 from "img/A-08.jpg";
import ico12 from "img/A-09.jpg";



const icon = 60;

const Info = ({ setPage }) => {
  const [mobileOpen, setMobileOpen] = React.useState(null);
  const [fetchload, setLoad] = React.useState(false);

  const setaction = (val, data) => {
    if (val) {
      setMobileOpen(data);
    } else {
      setMobileOpen(null);
    }
    setLoad(val);
  };

  return (
    <>
      <Card style={{ backgroundColor: "#19459D" }}>
        <CardContent>
          <div className="d-flex justify-content-center">
            <img src={head} width="250vw" />
          </div>
          <Card className="mb-5 mt-2" style={{ backgroundColor: "#E6E7E8" }}>
            <CardContent className="container mt-5">
              <h2 className="ml-3 text-left" style={{ color: "#19459D" }}>
                วีดิทัศน์
              </h2>
              <Box
                sx={{ width: { xs: "100%", md: "60%" } }}
                className="d-flex align-self-center">
                <iframe
                  src="https://youtube.com/embed/B9e4zabcBk4"
                  width="100%"
                  className="if"
                  height={400}
                />
              </Box>

              <h2 className="ml-3 text-left mt-5" style={{ color: "#19459D" }}>
                Infographic
              </h2>
              <Grid container spacing={2} className="mt-1">
              <Grid item md={4} onClick={() => setaction(true, ico1)} xs={12}>
                  <img src={ico1} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico2)} xs={12}>
                  <img src={ico2} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico3)} xs={12}>
                  <img src={ico3} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico4)} xs={12}>
                  <img src={ico4} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico5)} xs={12}>
                  <img src={ico5} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico6)} xs={12}>
                  <img src={ico6} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico7)} xs={12}>
                  <img src={ico7} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico8)} xs={12}>
                  <img src={ico8} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico9)} xs={12}>
                  <img src={ico9} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico10)} xs={12}>
                  <img src={ico10} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico11)} xs={12}>
                  <img src={ico11} />
                </Grid>
                <Grid item md={4} onClick={() => setaction(true, ico12)} xs={12}>
                  <img src={ico12} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </CardContent>
      </Card>

      <Dialog
        maxWidth="lg"
        TransitionComponent={Grow}
        fullScreen={window.innerWidth < 800 ? true : false}
        onClose={() => setaction(false, null)}
        open={fetchload}>
        <div className="text-right m-4">
          <CloseIcon onClick={() => setaction(false, null)} />
        </div>
        <DialogContent>
          <img src={mobileOpen} width="100%" height="auto" />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Info;
